<template>
    <div>
        <form data-vv-scope="family">
            <span class="block text-center text-2xl font-bold mb-8">{{
                $t("family")
            }}</span>
            <!--            <vs-checkbox v-model="laterDataOfFamily" class="mb-10">{{ $t('date_about_family_later') }}</vs-checkbox>-->
            <!--            <template v-if="!laterDataOfFamily">-->
            <div :class="classForDOM.grandParent">
                <vs-card>
                    <div :class="classForDOM.parent" class="items-center">
                        <div :class="classForDOM.block">
                            <vs-input-number
                                v-model="objectOfFamily.children_count"
                                :disabled="disabled"
                                name="children_count"
                                v-validate="'required|min_value:0'"
                                :label="`${$t('children_count')} :`"
                            />
                            <ValidateText
                                field="children_count"
                                scope="family"
                                :error="errors"
                            />
                        </div>
                        <div :class="classForDOM.block">
                            <vs-input-number
                                v-model="objectOfFamily.minor_children_count"
                                :disabled="disabled"
                                name="minor_children_count"
                                v-validate="'required|min_value:0'"
                                :label="`${$t('minor_children_count')} :`"
                            />
                            <ValidateText
                                field="minor_children_count"
                                scope="family"
                                :error="errors"
                            />
                        </div>
                    </div>
                </vs-card>
            </div>
            <div
                :class="classForDOM.grandParent"
                v-if="!objectOfFamily.uid && !disabled"
            >
                <vs-button type="relief" @click="customAddNewMember">{{
                    $t("add_family_member")
                }}</vs-button>
            </div>

            <template v-if="members.length">
                <div
                    v-for="member in members"
                    :key="member.uid"
                    :class="classForDOM.grandParent"
                >
                    <vs-card>
                        <div :class="classForDOM.parent">
                            <span class="text-xl font-semibold mb-4">
                                {{ member.profile.last_name }}
                                {{ member.profile.first_name }}
                                {{ member.profile.middle_name }}
                            </span>
                        </div>
                        <div
                            :class="classForDOM.parent"
                            v-if="listRelationDegree.length"
                        >
                            <vs-chip>
                                <vs-avatar />
                                {{
                                    listRelationDegree.find(
                                        (item) =>
                                            member.relation_degree === item.uid
                                    ).name
                                }}
                            </vs-chip>
                        </div>
                        <vs-divider></vs-divider>
                        <div class="pl-8">
                            <div :class="classForDOM.parent">
                                <span
                                    class="text-lg font-normal mb-2"
                                    style="color: black"
                                >
                                    {{ $t("profile") }}
                                </span>
                            </div>
                            <div
                                :class="classForDOM.parent"
                                class="member-information mb-4"
                            >
                                <div>
                                    <table>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("email") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.profile.email
                                                        ? member.profile.email
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("workplace") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.profile.workplace
                                                        ? member.profile
                                                              .workplace
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("position") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.profile.position
                                                        ? member.profile
                                                              .position
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div :class="classForDOM.parent">
                                <span
                                    class="text-lg font-normal mb-2"
                                    style="color: black"
                                >
                                    {{ $t("phone_number") }}

                                </span>
                            </div>
                            <div
                                :class="classForDOM.parent"
                                class="member-information mb-4"
                                v-for="(phone,p) in  member.phone"
                                v-bind:key="p"
                            >
                                <div>
                                    <table>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("phone_type") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    phone &&
                                                    phone.phone_type &&
                                                    listPhoneTypes.length
                                                        ? listPhoneTypes.find(
                                                              (t) => t.uid === phone.phone_type
                                                          ).name
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("phone_number") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    phone &&
                                                    phone.value
                                                        ? phone.value
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div :class="classForDOM.parent">
                                <span
                                    class="text-lg font-normal mb-2"
                                    style="color: black"
                                >
                                    {{ $t("address") }}
                                </span>
                            </div>
                            <div
                                :class="classForDOM.parent"
                                class="member-information mb-4"
                            >
                                <div>
                                    <table>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("county") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.address &&
                                                    member.address.data.country
                                                        ? member.address.data
                                                              .country
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("region") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.address &&
                                                    member.address.data.region
                                                        ? member.address.data
                                                              .region
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("district") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.address &&
                                                    member.address.data.district
                                                        ? member.address.data
                                                              .district
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("locality") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.address &&
                                                    member.address.data.locality
                                                        ? member.address.data
                                                              .locality
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("city") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                <template
                                                    v-if="
                                                        member.address &&
                                                        member.address.city_text
                                                    "
                                                >
                                                    {{
                                                        member.address.city_text
                                                            ? member.address
                                                                  .city_text
                                                            : $t("not_filled")
                                                    }}
                                                </template>
                                                <template v-else>
                                                    {{
                                                        member.address &&
                                                        member.address.data.city
                                                            ? member.address
                                                                  .data.city
                                                            : $t("not_filled")
                                                    }}
                                                </template>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("street") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.address &&
                                                    member.address.street
                                                        ? member.address.street
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("home_number") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.address &&
                                                    member.address.home_number
                                                        ? member.address
                                                              .home_number
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("corpus") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.address &&
                                                    member.address.corpus
                                                        ? member.address.corpus
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("apartment") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.address &&
                                                    member.address.apartment
                                                        ? member.address
                                                              .apartment
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-base font-semibold pr-20 pb-2"
                                            >
                                                {{ $t("index") }}
                                            </td>
                                            <td class="text-base pr-4 pb-2">
                                                {{
                                                    member.address &&
                                                    member.address.index
                                                        ? member.address.index
                                                        : $t("not_filled")
                                                }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <vs-divider></vs-divider>
                        <div
                            class="flex flex-col md:flex-row md:justify-end"
                            v-if="!disabled"
                        >
                            <vs-button
                                color="warning"
                                type="relief"
                                icon="edit"
                                @click="editMember(member)"
                                class="mb-4 md:mb-0 md:mr-4"
                            >
                                <!-- {{ $t("edit") }} -->
                            </vs-button>
                            <vs-button
                                color="danger"
                                type="relief"
                                icon="delete"
                                @click="removeMember(member)"
                            >
                                <!-- {{ $t("remove") }} -->
                            </vs-button>
                        </div>
                    </vs-card>
                </div>
            </template>

            <div
                :class="classForDOM.grandParent"
                v-if="objectOfFamily.uid && !disabled"
            >
                <vs-button type="relief" @click="openModalAddMember">{{
                    $t("add_family_member")
                }}</vs-button>
            </div>
            <!--            </template>-->
            <!--            <template v-else>-->
            <vs-alert
                v-if="!objectOfFamily.uid"
                color="dark"
                :title="$t('remark')"
                active="true"
            >
                {{ $t("remark_for_not_have_family") }}
            </vs-alert>
            <!--            </template>-->
        </form>

        <vs-popup
            color="primary"
            :active.sync="showModalAddMember"
            fullscreen
            :title="
                $t(memberForEdit ? 'edit_member_title' : 'add_member_title')
            "
            class="custom-popup"
        >
            <FamilyMemberForm
                :applicant-uid="memberForEdit?memberForEdit.profile.uid:''"
                :profile-abuterent-uid="data.profile.uid"
                :applicantNoProfileUid="data.uid"
                v-if="showModalAddMember"
                :data="memberForEdit"
                @closeModal="closeModal"
                @setNewListMembers="setNewListMembers"
                @clearObjectOfMemberForEdit="clearObjectOfMemberForEdit"
                :family-uid="objectOfFamily.uid"
                :dataOfApplicant="data"
            />
        </vs-popup>
    </div>
</template>

<script>
import ValidateText from "@/pages/Home/FillingInTheApplicantsData/widgets/ValidateText";
import FamilyMemberForm from "@/pages/Home/FillingInTheApplicantsData/Questionnaire/components/FamilyMemberForm";
export default {
    name: "Family",
    props: {
        data: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        ValidateText,
        FamilyMemberForm,
    },
    data() {
        return {
            objectOfFamily: {
                children_count: 1,
                minor_children_count: 0,
                profile: this.data.profile.uid,
                uid: null,
            },
            members: [],
            memberForEdit: null,
            laterDataOfFamily: true,
            showModalAddMember: false,
            classForDOM: {
                grandParent: "flex flex-col md:flex-row justify-between",
                parent: "flex flex-col md:flex-row justify-between items-start",
                block: "flex flex-col w-full",
            },
            listRelationDegree: [],
            listPhoneTypes: [],
            residentAddressStatus:'fijiji'
        };
    },
    methods: {
        async validateStep() {
            this.$emit("setNewDataInObject", {
                name: "family",
                data: {
                    data: this.objectOfFamily,
                    members: this.members,
                },
            });
            return true;
        },
        openModalAddMember() {
            this.showModalAddMember = true;
            // this.$store.commit('SET_WATCH_RADIO_TRUE_FALSE',[this.residentAddressStatus]);
        },
        async getUidFromObjectFamily() {
            try {
                this.$vs.loading();
                const response = (
                    await this.$http[this.objectOfFamily.uid ? "put" : "post"](
                        `admissions/families/${
                            this.objectOfFamily.uid
                                ? this.objectOfFamily.uid + "/"
                                : ""
                        }`,
                        this.objectOfFamily
                    )
                ).data;

                this.objectOfFamily.uid = response.uid;
                this.openModalAddMember();
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        customAddNewMember() {
            try {
                this.getUidFromObjectFamily();
            } catch (e) {
            } finally {
            }
        },
        async getListRelationDegree() {
            try {
                this.listRelationDegree = (
                    await this.$http.get("user/relation-degrees/")
                ).data;
                this.listPhoneTypes = (
                    await this.$http.get("user/phone-types/")
                ).data;
            } catch (e) {
            } finally {
            }
        },
        async removeMember(value) {
            try {
                this.$vs.loading();

                this.respone = (
                    await this.$http.delete(`admissions/members/${ value.uid }/`)
                ).data;
                this.members = this.members.filter((m) => m.uid !== value.uid);
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
        editMember(value) {
            this.memberForEdit = value;
            this.openModalAddMember();
        },
        clearObjectOfMemberForEdit() {
            this.memberForEdit = null;
        },
        setNewListMembers(list) {
            this.members = list;
        },
        closeModal() {
            this.showModalAddMember = false;
        },
    },
    created() {
        this.getListRelationDegree();
        if (this.data.family.data) {
            for (let key in this.objectOfFamily) {
                this.objectOfFamily[key] = this.data.family.data[key];
            }
            this.laterDataOfFamily = false;
            if (this.data.family.members) {
                this.members = this.data.family.members;
            }
        }
    },
};
</script>

<style scoped lang="scss">
//.custom-popup::v-deep{
//    .vs-popup--content{
//        min-height: 100%;
//    }
//}
.member-information {
    table {
        td {
            vertical-align: top;
            min-width: 140px;
            padding-bottom: 0.8rem;
            word-break: break-all;
        }
        &:not(.permissions-table) {
            td {
                @media screen and (max-width: 600px) {
                    display: block;
                }
            }
        }
    }
}
</style>
